module.exports = __webpack_public_path__ + "img/m-menu.3c2f5b99.svg";